import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import cx from 'classnames';

import Exempel from '../Information/RelevantInnehall';
import i from './FactImageThumbnail.css';

import Fact from './Fact';

function HoC(props) {
  return (
    <Fact
      id="relevant"
      className="clearfix"
      title="Relevant innehåll"
      {...props}
    >
      <p>
        {`
          Kostrådet ska spegla livsmedlets innehåll för att inte
          vilseleda konsumenten.
        `}
      </p>
      <h4>{'För kostråd om att ”äta mer av” eller ”byta till”'}</h4>
      <p>
        {`
          Vill du använda ett kostråd som uppmanar till att äta mer av eller
          byta till, är det viktigt att produkten också innehåller en
          tillräckligt stor mängd av det som lyfts fram i kostrådet.
          Annars finns risk för att konsumenten blir vilseledd.
          Ta gärna hjälp av nyckelhålskriterierna för att bedöma vad
          tillräckligt stor mängd är för den ingrediens/det näringsämne
          som lyfts fram i kostrådet.
        `}
      </p>
      <p className={cx(i.mt0, i.root)}>
        <a
          rel="noopener noreferrer"
          target="_blank"
          href="https://www.livsmedelsforetagen.se/app/uploads/2016/10/dokument.pdf"
        >
          <img
            className={i.image}
            alt=""
            src="https://s3-eu-west-1.amazonaws.com/kostradsguiden/markningshandboken.jpg"
          />
        </a>
      </p>
      <p>
        {`
          Om du använder ett kostråd som uppmanar till att äta mer av eller
          byta till bör mängden av det som rekommenderas anges. Information
          om hur du ska märka mängd av en ingrediens finns i
        `}
        <a
          rel="noopener noreferrer"
          target="_blank"
          href="https://www.livsmedelsforetagen.se/app/uploads/2016/10/dokument.pdf"
        >
          {'Livsmedelsföretagens märkningshandbok'}
        </a>{' '}
        {`
          på sid 50–58 under rubriken
          ”Mängdangivelse av ingredienser”.
        `}
      </p>

      <Exempel />

      <h4>
        {'Speciellt att tänka på för kostrådet  ”Byt till nyttiga matfetter”'}
      </h4>
      <p>
        {`
          Produkter som tillhör  livsmedelsgrupperna 3, 19 och 20 i
          Livsmedelsverkets föreskrift om Nyckelhålet (LIVSFS 2005:9, konsoliderad
          version LIVSFS 2015:1) OCH som uppfyller kriteriet för mättat fett
          kan märkas med kostrådet ”Byt till nyttiga matfetter” eller annan
          likvärdig formulering.
        `}
      </p>
      <p>
        {`
          Detta kostråd måste kombineras med ett specifikt hälsopåstående i
          EU-förordning 432/2012. Välj bland följande hälsopåståenden:
        `}
      </p>
      <ul>
        <li>
          <a
            rel="noopener noreferrer"
            target="_blank"
            href="http://eur-lex.europa.eu/legal-content/SV/TXT/PDF/?uri=CELEX:02012R0432-20160914&qid=1487163231292&from=SV"
          >
            {`
              Att ersätta mättat fett i kosten med omättat fett bidrar till att
              bibehålla normala kolesterolnivåer i blodet.
            `}
          </a>
          {' Sid 8'}
        </li>
        <li>
          <a
            rel="noopener noreferrer"
            target="_blank"
            href="http://eur-lex.europa.eu/legal-content/SV/TXT/PDF/?uri=CELEX:02012R0432-20160914&qid=1487163231292&from=SV"
          >
            {`
              Minskat intag av mättat fett bidrar till att bibehålla normala
              kolesterolnivåer i blodet.
            `}
          </a>
          {' Sid 23'}
        </li>
        <li>
          <a
            rel="noopener noreferrer"
            target="_blank"
            href="http://eur-lex.europa.eu/legal-content/SV/TXT/PDF/?uri=CELEX:02012R0432-20160914&qid=1487163231292&from=SV"
          >
            {`
              Alfa-linolensyra (ALA) bidrar till att bibehålla normala
              kolesterolnivåer i blodet.
            `}
          </a>
          {' Sid 3'}
        </li>
        <li>
          <a
            rel="noopener noreferrer"
            target="_blank"
            href="http://eur-lex.europa.eu/legal-content/SV/TXT/PDF/?uri=CELEX:02012R0432-20160914&qid=1487163231292&from=SV"
          >
            {`
              Linolsyra bidrar till att bibehålla normala kolesterolnivåer
              i blodet.
            `}
          </a>
          {' Sid 23'}
        </li>
      </ul>
      <p>
        {`
          Möjlighet finns att använda alternativa ordalydelse för
          hälsopåståenden förutsatt att syftet är att hjälpa konsumenten att
          förstå påståendet och att det inte medför att påståendet får en annan
          innebörd för konsumenten.
        `}
      </p>
      <p>
        {`
          Ta även hänsyn till övriga min-/maxvärden i nyckelhålsreglerna för
          din produkt och gör en bedömning att det inte blir vilseledande vad
          gäller livsmedlets nyttighet som helhet.
        `}
        {'Läs mer under rubriken ”Vilseledande”.'}
      </p>

      <h4>{'Speciellt att tänka på för kostrådet ”Ät mindre salt” '}</h4>
      <p>{'”Ät mindre salt” är både ett kostråd och ett näringspåstående.'}</p>
      <p>
        {`
          Produkter som tillhör någon av de 33 livsmedelsgrupper som innefattar
          kriterium för salt i Livsmedelsverkets föreskrift om Nyckelhålet
          (LIVSFS 2005:9, konsoliderad version LIVSFS 2015:1) OCH som uppfyller
          detta kriterium får märkas med kostrådet ”Ät mindre salt” eller annan
          likvärdig formulering (t ex ”mindre salt”).
        `}
      </p>
      <p>
        {`
          Kombinera gärna rådet ”Ät mindre salt” med hälsopåståendet
        `}
        <a
          rel="noopener noreferrer"
          target="_blank"
          href="http://eur-lex.europa.eu/legal-content/SV/TXT/PDF/?uri=CELEX:02012R0432-20160914&qid=1487163231292&from=SV"
        >
          {`
            ”minskat intag av salt bidrar till att bibehålla normalt blodtryck”
          `}
        </a>
        {'enligt EU-förordning 432/2012 sid 23.'}
      </p>
      <p>
        {`
          Ta även hänsyn till övriga min-/maxvärden i nyckelhålsreglerna för din
          produkt och gör en bedömning att det inte blir vilseledande vad gäller
          livsmedlets nyttighet som helhet.
        `}
        {'Läs mer under rubriken ”Vilseledande”.'}
      </p>

      <h4>{'Speciellt att tänka på för kostrådet ”Ät mindre socker”'}</h4>
      <p>
        {`
          ”Ät mindre socker” är både ett kostråd och ett näringspåstående.
        `}
      </p>
      <p>
        {`
          Produkter som tillhör någon av de 33 livsmedelsgrupper som innefattar
          kriterium för sockerarter i Livsmedelsverkets föreskrift om Nyckelhålet
          (LIVSFS 2005:9, konsoliderad version LIVSFS 2015:1) OCH som uppfyller
          detta kriterium får märkas med kostrådet ”Ät mindre socker” eller
          annan likvärdig formulering (t ex ”mindre socker”).
        `}
      </p>
      <p>
        {`
          Ta även hänsyn till övriga min-/maxvärden i nyckelhålsreglerna för
          din produkt och gör en bedömning att det inte blir vilseledande vad
          gäller livsmedlets nyttighet som helhet.
        `}
        {'Läs mer under rubriken ”Vilseledande”.'}
      </p>
    </Fact>
  );
}

export default withStyles(i)(HoC);



// WEBPACK FOOTER //
// ./src/components/Fact/FactRelevantInnehall.js